// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GetStartedComponent } from './get-started/get-started.component';
import { InviteUserComponent } from './invite-user/invite-user.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { NewPasswordComponent } from './new-password/new-password.component';
import { ResetPasswordFormComponent } from './reset-password-form/reset-password-form.component';
import { ResetTokenFormComponent } from './reset-token-form/reset-token-form.component';
import { TokenVerifyComponent } from './token-verify/token-verify.component';
import { EnterVerificationComponent } from './two-factor-auth/enter-verification/enter-verification.component';
import { SelfEnrollmentRoutingModule } from './self-enrollment/self-enrollment-routing.module';
import { RequestAccessFormComponent } from './request-access-form/request-access-form.component';

const routes: Routes = [
    {
        path: '',
        component: LoginFormComponent,
    },
    {
        path: 'new-password',
        component: NewPasswordComponent,
    },
    {
        path: 'reset-password',
        component: ResetPasswordFormComponent,
    },
    {
        path: 'reset-token',
        component: ResetTokenFormComponent,
    },
    {
        path: 'code',
        component: TokenVerifyComponent,
    },
    {
        path: 'get-started/:email/:password',
        component: GetStartedComponent,
    },
    {
        path: 'invite-user/:email/:password',
        component: InviteUserComponent,
    },
    {
        path: 'two-factor-auth/verify',
        component: EnterVerificationComponent,
    },
    {
        path: 'request-access/:jacketId',
        component: RequestAccessFormComponent,
    },
    {
        path: 'firstUserLogging',
        loadChildren: () => SelfEnrollmentRoutingModule,
    },
    {
        path: 'self-enrollment',
        loadChildren: () => SelfEnrollmentRoutingModule,
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class LoginRoutingModule {}
